import { useCallback } from 'react'

import { DISPLAY_DATE_FORMAT } from '../../../utils/dayjs'
import { include } from '../../../utils/javascript'
import {
  booleanOptions,
  NO,
  typeOfStaffAvailableOptions,
  YES,
} from '../jobs.description'

const inspectionFieldAttr = () => {
  const administrationAttrFn = useCallback(
    ({
      awtParticipateActivities = null,
      awtPresentAtTimeOfVisit = null,
      awhPresentAtTimeOfVisit = null,
      // awcOpenedLocation = null,
      areStockRegistersUpdated = null,
      studentAttendanceRegistersUpdated = null,
      // anyVacancyAvailableForAwtAwh = null,
    } = {}) => ({
      staffTypeAvailable: {
        label: 'job_WhatTypeOfStaffIsAvailable',
        inputType: 'CHECKBOX',
        options: typeOfStaffAvailableOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      isAwtAvailableMondayToSaturday: {
        label: 'job_IsTheAWTAvailableFromMondayToSaturday',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      isAwhAvailableMondayToSaturday: {
        label: 'job_IsTheAWHAvailableFromMondayToSaturday',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      doesAwtAwhTakeFrequentBreaks: {
        label: 'job_DoesAWTAWHTakeFrequentBreaks',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      doesAwtAwhParticipateInOtherActivities: {
        label: 'job_DoesAWTAWHParticipateInOtherActivities',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], awtParticipateActivities) && {
        specifyOtherActivities: {
          label: 'job_Specify',
          inputType: 'input',
          required: true,
          md: 24,
          xs: 24,
        },
      }),
      awtWorkingHoursPerDay: {
        label: 'job_HowManyHoursInADayAWTWorking',
        inputType: 'inputNumber',
        className: 'w-100',
        required: true,
        md: 24,
        xs: 24,
      },
      awhWorkingHoursPerDay: {
        label: 'job_HowManyHoursInADayAWHWorking',
        inputType: 'inputNumber',
        className: 'w-100',
        required: true,
        md: 24,
        xs: 24,
      },
      whetherAwtPresentAtTimeOfVisit: {
        label: 'awc_whetherAwtPresentAtThe',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: [
          { label: 'btn_Yes', value: 'YES' },
          { label: 'btn_No', value: 'NO' },
          { label: 'awc_Vacant', value: 'VACANT' },
        ],
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([NO, 'btn_No'], awtPresentAtTimeOfVisit) && {
        awtNotPresentReason: {
          label: 'awc_pleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      ...(include(['VACANT', 'awc_Vacant'], awtPresentAtTimeOfVisit) && {
        awtVacantHowLong: {
          label: 'awc_ifVacantHowLong',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      whetherAwhPresentAtTimeOfVisit: {
        label: 'awc_whetherAwhPresentAtThe',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: [
          { label: 'btn_Yes', value: 'YES' },
          { label: 'btn_No', value: 'NO' },
          { label: 'awc_Vacant', value: 'VACANT' },
        ],
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([NO, 'btn_No'], awhPresentAtTimeOfVisit) && {
        awhNotPresentReason: {
          label: 'awc_pleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      ...(include(['VACANT'], awhPresentAtTimeOfVisit) && {
        awhVacantHowLong: {
          label: 'awc_ifVacantHowLong',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      whetherAwcOpenedOnTime: {
        label: 'awc_whetherAwcOpenedOnTime',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      // whetherAwcOpened: {
      //   label: 'awc_whetherAwcOpened',
      //   inputType: 'select',
      //   options: [
      //     { label: 'awc_withinThePremises', value: 'WITHIN_PREMISES' },
      //     { label: 'awc_outsidePremises', value: 'OUTSIDE_PREMISES' },
      //   ],
      //   required: true,
      //   className: 'w-100',
      //   md: 24,
      //   xs: 24,
      // },
      // ...(include(['OUTSIDE_PREMISES'], awcOpenedLocation) && {
      //   awcOpenedOutsideReason: {
      //     label: 'awc_pleaseSpecifyReason',
      //     inputType: 'input',
      //     required: true,
      //     className: 'w-100',
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
      areStockRegistersUpdated: {
        label: 'awc_areTheStockRegistersUpdated',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([NO, 'btn_No'], areStockRegistersUpdated) && {
        stockRegistersLastUpdateDate: {
          label: 'awc_whatIsTheDateOf',
          inputType: 'dateTimePicker',
          format: DISPLAY_DATE_FORMAT,
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      areStudentAttendanceRegistersMaintainedUpToDate: {
        label: 'awc_areTheStudentAttendanceRegisters',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([NO, 'btn_No'], studentAttendanceRegistersUpdated) && {
        studentAttendanceRegistersLastUpdateDate: {
          label: 'awc_whatIsTheDateOf',
          inputType: 'dateTimePicker',
          format: DISPLAY_DATE_FORMAT,
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      // anyVacancyAvailableForAwtAwh: {
      //   label: 'job_AnyVacancyAvailableForAWTAWH',
      //   inputType: 'select',
      //   required: true,
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   md: 24,
      //   xs: 24,
      // },
      // ...(include([YES, 'btn_Yes'], anyVacancyAvailableForAwtAwh) && {
      //   vacancyAvailableForAwtAwh: {
      //     label: 'job_VacancyAvailableForAWTAWH',
      //     inputType: 'select',
      //     required: true,
      //     responsiveInputType: 'RADIO_BUTTON',
      //     options: typeOfStaffAvailableOptions,
      //     md: 24,
      //     xs: 24,
      //   },
      //   vacancyAvailableForAwtAwhHowLong: {
      //     label: 'job_HowLongTime',
      //     inputType: 'input',
      //     required: true,
      //     className: 'w-100',
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
    }),
    [],
  )

  const childrenAttrFn = useCallback(
    ({
      childrenPresentInUniform,
      breakfastGiven = null,
      lunchGiven = null,
      // samChildrenPresentAtTimeOfVisit = null,
      // mamChildrenPresentAtTimeOfVisit = null,
      disableChildEnrolled = null,
      // numberOfChildrenEnrolledAwc = null,
      // numberOfLactatingWomenEnrolledAwc = null,
      // numberOfPregnantWomenEnrolledAwc = null,
    } = {}) => ({
      children: {
        title: 'job_Children',
      },
      numberOfChildrenEnrolledAwc: {
        label: 'job_TotalChildrenEnrolledInAWC',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      numberOfChildrenPresentAtTimeOfVisit: {
        label: 'job_TotalChildrenAttendedPresentAtTimeOfVisit',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      totalNoOfBoys: {
        label: 'job_TotalNoOfBoys',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      totalNoOfGirls: {
        label: 'job_TotalNoOfGirls',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      childrenPresentInUniform: {
        label: 'job_WhetherAllChildrenPresentInUniform',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      ...(include([NO, 'btn_No'], childrenPresentInUniform) && {
        childrenNotPresentInUniformReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      // childBeneficiariesDetails: {
      //   label: '',
      //   inputType: 'table',
      //   userType: 'job_Children',
      //   required: !!numberOfChildrenEnrolledAwc,
      //   md: 24,
      //   xs: 24,
      // },
      isRecommendedNutritionGivenByAwt: {
        label: 'job_IsTheRecommendedNutritionGivenByTheAWTToTheChildChildren',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      isBreakfastGiven: {
        label: 'job_IsBreakfastGiven',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], breakfastGiven) && {
        breakfastTime: {
          label: 'job_BreakfastAtWhatTime',
          inputType: 'timePicker',
          format: 'HH:mm',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      isLunchGiven: {
        label: 'job_IsLunchGiven',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], lunchGiven) && {
        lunchTime: {
          label: 'job_LunchAtWhatTime',
          inputType: 'timePicker',
          format: 'HH:mm',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      isHygieneMaintainedByAwtAwh: {
        label: 'job_IsHygieneBeingMaintainedByTheAWTAWH',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      totalNoOfSamChildrenInAwc: {
        label: 'job_TotalNoOfSamChildrenInAwc',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      noOfSamChildrenBoysInAwc: {
        label: 'job_NoOfSAMBoysInAWC',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
        rules: (fieldPath, t) => [
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (value != null && value !== '') {
                const totalPath = [
                  'inspectionList',
                  ...fieldPath,
                  'totalNoOfSamChildrenInAwc',
                ]
                const totalValue = getFieldValue(totalPath)
                if (
                  totalValue == null ||
                  totalValue === '' ||
                  value > totalValue
                ) {
                  return Promise.reject(t('error_BoysValueExceedsTotal'))
                }
              }
              return Promise.resolve()
            },
          }),
        ],
      },
      noOfSamChildrenGirlsInAwc: {
        label: 'job_NoOfSAMGirlsInAWC',
        inputType: 'inputNumber',
        // required: true,
        disabled: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      whetherSamChildrenPresentAtTimeOfVisit: {
        label: 'job_WhetherSamChildrenPresentAtTimeOfVisit',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      // ...(include([NO, 'btn_No'], samChildrenPresentAtTimeOfVisit) && {
      //   samChildrenNotPresentReason: {
      //     label: 'job_PleaseSpecifyReason',
      //     inputType: 'input',
      //     required: true,
      //     className: 'w-100',
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
      totalNoOfMamChildrenInAwc: {
        label: 'job_TotalNoOfMamChildrenInAwc',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      noOfMamChildrenBoysInAwc: {
        label: 'job_NoOfMAMBoysInAWC',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
        rules: (fieldPath, t) => [
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (value != null && value !== '') {
                const totalPath = [
                  'inspectionList',
                  ...fieldPath,
                  'totalNoOfMamChildrenInAwc',
                ]
                const totalValue = getFieldValue(totalPath)
                if (
                  totalValue == null ||
                  totalValue === '' ||
                  value > totalValue
                ) {
                  return Promise.reject(t('error_BoysValueExceedsTotal'))
                }
              }
              return Promise.resolve()
            },
          }),
        ],
      },
      noOfMamChildrenGirlsInAwc: {
        label: 'job_NoOfMAMGirlsInAWC',
        inputType: 'inputNumber',
        // required: true,
        disabled: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      whetherMamChildrenPresentAtTimeOfVisit: {
        label: 'job_WhetherMamChildrenPresentAtTimeOfVisit',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      // ...(include([NO, 'btn_No'], mamChildrenPresentAtTimeOfVisit) && {
      //   mamChildrenNotPresentReason: {
      //     label: 'job_PleaseSpecifyReason',
      //     inputType: 'input',
      //     required: true,
      //     className: 'w-100',
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
      whetherAnyDisableChildEnrolledInAwc: {
        label: 'job_WhetherAnyDisableChildEnrolledInAwc',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], disableChildEnrolled) && {
        disableChildEnrolledRemarks: {
          label: 'job_WriteRemarks',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      pregnantWomen: {
        title: 'job_PregnantWomen',
      },
      numberOfPregnantWomenEnrolledAwc: {
        label: 'job_TotalNoOfPregnantWomenEnrolledThisMonth',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      numberOfPregnantWomenPresentAtTimeOfVisit: {
        label: 'job_TotalNoOfPregnantWomenPresentAtTimeOfVisit',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      // pregnantWomenBeneficiariesDetails: {
      //   label: '',
      //   inputType: 'table',
      //   userType: 'job_PregnantWomen',
      //   required: !!numberOfPregnantWomenEnrolledAwc,
      //   md: 24,
      //   xs: 24,
      // },
      lactatingWomen: {
        title: 'job_LactatingWomen',
      },
      numberOfLactatingWomenEnrolledAwc: {
        label: 'job_TotalNoOfLactatingWomenEnrolledThisMonth',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      numberOfLactatingWomenPresentAtTimeOfVisit: {
        label: 'job_TotalNoOfLactatingWomenPresentAtTimeOfVisit',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      // lactatingWomenBeneficiariesDetails: {
      //   label: '',
      //   inputType: 'table',
      //   userType: 'job_LactatingWomen',
      //   required: !!numberOfLactatingWomenEnrolledAwc,
      //   md: 24,
      //   xs: 24,
      // },
      // signatureDmsIds: {
      //   label: 'job_TakeSignature',
      //   inputType: 'canvas',
      //   uploadSingle: true,
      //   galleryUpload: true,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // evidenceDmsIds: {
      //   label: 'job_FaceEvidence',
      //   inputType: 'formUpload',
      //   uploadSingle: true,
      //   galleryUpload: true,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
    }),
    [],
  )
  const hostelInfraRoomsAttrFn = useCallback(
    ({
      isElectricity = null,
      hasBolaPaintings = null,
      freshPaintingNeeded = null,
      nutriGardenAvailable = null,
      doesAwcHaveBasicAmenities = null,
      doesAwcHaveDesignatedLearningCorners = null,
      doesAwcHaveAdequateFurniture = null,
      doesAwcHavePlayEquipments = null,
      areFansLightsWorkingEfficiently = null,
      // toiletsRepairsFeedback = null,
    } = {}) => ({
      anganwadiLocationType: {
        label: 'job_WhetherAnganwadiIsOnPublicOrPrivateLand',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: [
          { label: 'job_Public', value: 'PUBLIC' },
          { label: 'job_Private', value: 'PRIVATE' },
        ],
        required: true,
        md: 24,
        xs: 24,
      },
      typeOfBuilding: {
        label: 'awc_typeOfBuilding',
        inputType: 'select',
        options: [
          { label: 'awc_rentFree', value: 'RENT_FREE' },
          { label: 'awc_spacing', value: 'SPACING' },
        ],
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      // numberOfAnganwadiCentresSameLocation: {
      //   label: 'job_NumberOfAnganwadiCentresInTheSameLocation',
      //   inputType: 'inputNumber',
      //   required: true,
      //   className: 'w-100',
      //   md: 24,
      //   xs: 24,
      // },
      conditionOfBuildingWallsAndRoof: {
        label: 'job_ConditionOfBuildingWallsAndRoof',
        inputType: 'select',
        mode: 'multiple',
        options: [
          {
            label: 'job_GoodStructurallySound',
            value: 'GOOD_STRUCTURALLY_SOUND',
          },
          { label: 'job_NeedsMinorRepairs', value: 'NEEDS_MINOR_REPAIRS' },
          {
            label: 'job_PoorDilapidatedUnsafe',
            value: 'POOR_DILAPIDATED_UNSAFE',
          },
        ],
        required: true,
        md: 24,
        xs: 24,
      },
      whetherAwcIsHavingBolaArtisticPaintings: {
        label: 'job_WhetherAwcIsHavingBolaPaintings',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], hasBolaPaintings) && {
        bolaArtisticPaintingsPhotoDmsIds: {
          label: 'job_BolaPaintingsPhoto',
          inputType: 'formUpload',
          acceptFileTypes: '.png,.jpg,.jpeg',
          uploadSingle: true,
          galleryUpload: true,
          required: true,
          md: 24,
          xs: 24,
        },
      }),
      whetherFreshPaintingNeeded: {
        label: 'job_WhetherFreshPaintingNeeded',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], freshPaintingNeeded) && {
        freshPaintingPhotoDmsIds: {
          label: 'job_FreshPaintingPhoto',
          inputType: 'formUpload',
          acceptFileTypes: '.png,.jpg,.jpeg',
          uploadSingle: true,
          galleryUpload: true,
          required: true,
          md: 24,
          xs: 24,
        },
      }),
      numberOfRoomsAvailable: {
        label: 'job_NumberOfRoomsAvailable',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      areRoomsSufficientForAllStudents: {
        label: 'job_AreRoomsSufficientForAllStudents',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      doesAnganwadiCentreHaveDesignatedLearningCorners: {
        label: 'job_DoesAwcHaveDesignatedLearningCorners',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], doesAwcHaveDesignatedLearningCorners) && {
        designatedLearningCornersPhotoDmsIds: {
          label: 'job_DesignatedLearningCornersPhoto',
          inputType: 'formUpload',
          acceptFileTypes: '.png,.jpg,.jpeg',
          uploadSingle: true,
          galleryUpload: true,
          required: true,
          md: 24,
          xs: 24,
        },
      }),
      ...(include([NO, 'btn_No'], doesAwcHaveDesignatedLearningCorners) && {
        designatedLearningCornersNotAvailableReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      doesAnganwadiCentreHaveAdequateFurnitureAvailable: {
        label: 'job_DoesAwcHaveAdequateFurniture',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], doesAwcHaveAdequateFurniture) && {
        adequateFurniturePhotoDmsIds: {
          label: 'job_AdequateFurniturePhoto',
          inputType: 'formUpload',
          acceptFileTypes: '.png,.jpg,.jpeg',
          uploadSingle: true,
          galleryUpload: true,
          required: true,
          md: 24,
          xs: 24,
        },
      }),
      ...(include([NO, 'btn_No'], doesAwcHaveAdequateFurniture) && {
        adequateFurnitureNotAvailableReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      doesAnganwadiCentreHavePlayEquipments: {
        label: 'job_DoesAwcHavePlayEquipments',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], doesAwcHavePlayEquipments) && {
        playEquipmentsPhotoDmsIds: {
          label: 'job_PlayEquipmentsPhoto',
          inputType: 'formUpload',
          acceptFileTypes: '.png,.jpg,.jpeg',
          galleryUpload: true,
          max: 5,
          required: true,
          md: 24,
          xs: 24,
        },
      }),
      ...(include([NO, 'btn_No'], doesAwcHavePlayEquipments) && {
        playEquipmentsNotAvailableReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      // howDoesTheCenterLookLike: {
      //   label: 'job_HowDoesTheCenterLookLike',
      //   inputType: 'select',
      //   options: [
      //     { label: 'job_Pleasantly', value: 'PLEASANTLY' },
      //     { label: 'job_SlightlyPleasant', value: 'SLIGHTLY_PLEASANT' },
      //     { label: 'job_Disappointing', value: 'DISAPPOINTING' },
      //   ],
      //   required: true,
      //   className: 'w-100',
      //   md: 24,
      //   xs: 24,
      // },
      isClassroomSufficientForTotalChildren: {
        label: 'job_IsTheClassroomSufficientForTheTotalNumberOfChildren',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      isAnganwadiCentreSharedWithPrimaryHighSchool: {
        label: 'job_IsTheAnganwadiCentreBeingSharedWithPrimaryHighSchool',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      // doesCentreHaveOwnSecurity: {
      //   label: 'job_DoesThisCentreHasItsOwnSecurity',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // doesCentreShareSecurityWithOthers: {
      //   label:
      //     'job_DoesThisCentreSharesItSecurityWithOthersLikePrimarySchoolEtc',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      isThereGoodVentilation: {
        label: 'job_IsThereIsGoodVentilation',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      numberOfWindowsPresent: {
        label: 'job_NumberOfWindowsPresent',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      numberOfDoorsPresent: {
        label: 'job_NumberOfDoorsPresent',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      windowDoorIssues: {
        label: 'job_WhichOfTheFollowingAreIssuesInWindowsOrDoors',
        inputType: 'select',
        mode: 'multiple',
        options: [
          { label: 'job_BrokenNoDoors', value: 'BROKEN_NO_DOORS' },
          { label: 'job_BrokenNoGlass', value: 'BROKEN_NO_GLASS' },
          { label: 'job_BrokenNoGrill', value: 'BROKEN_NO_GRILL' },
          { label: 'job_BrokenNoMesh', value: 'BROKEN_NO_MESH' },
          { label: 'txt_None', value: 'NONE' },
        ],
        required: true,
        md: 24,
        xs: 24,
      },
      cookingFacilityType: {
        label:
          'job_DoesTheCentreHaveProperCookwareGasCylinderStoveOrStillCookingOnFireWoods',
        inputType: 'select',
        options: [
          { label: 'job_Cookware', value: 'COOKWARE' },
          { label: 'job_GasCylinderStove', value: 'GAS_CYLINDER_STOVE' },
          { label: 'job_FireWoods', value: 'FIREWOOD' },
        ],
        mode: 'multiple',
        required: true,
        md: 24,
        xs: 24,
      },
      whetherNutriGardenAvailableMaintained: {
        label: 'job_WhetherNutriGardenAvailableMaintained',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], nutriGardenAvailable) && {
        nutriGardenPhotoDmsIds: {
          label: 'job_NutriGardenPhoto',
          inputType: 'formUpload',
          acceptFileTypes: '.png,.jpg,.jpeg',
          uploadSingle: true,
          galleryUpload: true,
          required: true,
          md: 24,
          xs: 24,
        },
      }),
      ...(include([NO, 'btn_No'], nutriGardenAvailable) && {
        nutriGardenNotAvailableReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      electricity: {
        title: 'job_Electricity',
      },
      isElectricityAvailable: {
        label: 'job_IsElectricityAvailable',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], isElectricity) && {
        electricitySource: {
          label: 'job_IsItFromLocalLineElectricityOrSolarPanel',
          inputType: 'select',
          options: [
            { label: 'job_LocalLine', value: 'LOCAL_LINE' },
            { label: 'job_SolarPanel', value: 'SOLAR_PANEL' },
          ],
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      doesAwcHaveBasicAmenities: {
        label: 'job_DoesAwcHaveBasicAmenities',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([NO, 'btn_No'], doesAwcHaveBasicAmenities) && {
        basicAmenitiesNotAvailableReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      areFansLightsWorkingEfficiently: {
        label: 'job_AreTheyWorkingEfficiently',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      ...(include(['NO', 'btn_No'], areFansLightsWorkingEfficiently) && {
        electrificationRepairsRequired: {
          label: 'job_DescribeElectrificationRepairsRequired',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      toilets: {
        title: 'job_Toilets',
      },
      numberOfToiletsAvailable: {
        label: 'job_HowManyToiletsAreAvailable',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      doesCentreHaveSeparateToilet: {
        label: 'job_DoesThisCentreHasSeparateToilet',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      // areToiletsSharedWithPrimarySchool: {
      //   label: 'job_AreTheToiletsSharedWithPrimarySchool',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   className: 'w-100',
      //   md: 24,
      //   xs: 24,
      // },
      toiletsRepairsFeedback: {
        label: 'job_FeedbackForAnyRepairsNeededForTheToilets',
        inputType: 'input',
        required: true,
        md: 24,
        xs: 24,
      },
      toiletsPhoto1Ids: {
        label: 'job_PhotoOfToilets1',
        inputType: 'formUpload',
        acceptFileTypes: '.png,.jpg,.jpeg',
        uploadSingle: true,
        galleryUpload: true,
        required: true,
        md: 24,
        xs: 24,
      },
      toiletsPhoto2Ids: {
        label: 'job_PhotoOfToilets2',
        inputType: 'formUpload',
        acceptFileTypes: '.png,.jpg,.jpeg',
        uploadSingle: true,
        galleryUpload: true,
        required: true,
        md: 24,
        xs: 24,
      },
      drinkingWater: {
        title: 'job_DrinkingWater',
      },
      sourceOfDrinkingWater: {
        label: 'job_SourceOfDrinkingWater',
        inputType: 'select',
        mode: 'multiple',
        options: [
          { label: 'job_Bore', value: 'BORE' },
          { label: 'job_RO', value: 'RO' },
          { label: 'job_Municiple', value: 'MUNICIPLE' },
          { label: 'job_OpenWell', value: 'OPEN_WELL' },
        ],
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      isDrinkingWaterSharedWithOthers: {
        label: 'job_IsDrinkingWaterBeingSharedWithOthersLikePrimarySchool',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      wasteManagement: {
        title: 'job_WasteManagement',
      },
      isAnganwadiPremisesKeptCleanInsideOutside: {
        label: 'job_IsTheAnganwadiCentrePremisesKeptCleanInsideAndOutside',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      isSolidWasteRegularlyClearedByGpMunicipality: {
        label: 'job_IsSolidWasteRegularlyClearedByGPMunicipality',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      isWasteDisposedInOpenAreas: {
        label: 'job_IsWasteDisposedInOpenAreas',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        md: 24,
        xs: 24,
      },
      areGreyWaterAndBlackWaterDrainedSeparately: {
        label: 'job_AreGreyWaterAndBlackWaterDrainedSeparately',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        md: 24,
        xs: 24,
      },
      isThereClosedOrOpenDrainageSystem: {
        label: 'job_IsThereAClosedOrOpenDrainageSystemInTheLocality',
        inputType: 'select',
        options: [
          { label: 'job_Closed', value: 'CLOSE' },
          { label: 'job_Open', value: 'OPEN' },
        ],
        required: true,
        md: 24,
        xs: 24,
      },
    }),
    [],
  )
  const educationAttrFn = useCallback(
    ({
      dailyEcceActivitiesConducted = null,
      ecceDayConducted = null,
    } = {}) => ({
      isLearningSyllabusBeingFollowed: {
        label: 'job_IsTheLearningSyllabusBeingFollowed',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      isAttendanceBeingTaken: {
        label: 'job_IsAttendanceBeingTaken',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      isLearningAidBeingUsedForChildren: {
        label: 'job_IsLearningAidBeingUsedForTheChildren',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      areClassroomsDigitalized: {
        label: 'job_AreClassroomsDigitalized',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      whetherBoardersSuppliedWithSchoolAccessories: {
        label: 'job_WhetherChildrenAreSuppliedWithSchoolAccessories',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      distanceOfAnganwadiToNearbyStudentsLocationsKm: {
        label:
          'job_DistanceOfTheAnganwadiToTheNearbyStudentsLocationsApproximatelyInKM',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      wereDailyEcceActivitiesConductedAsPerSchedule: {
        label: 'job_WereDailyEcceActivitiesConductedAsPerSchedule',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], dailyEcceActivitiesConducted) && {
        dailyEcceActivitiesPhotoDmsIds: {
          label: 'job_DailyEcceActivitiesPhoto',
          inputType: 'formUpload',
          acceptFileTypes: '.png,.jpg,.jpeg',
          uploadSingle: true,
          galleryUpload: true,
          required: true,
          md: 24,
          xs: 24,
        },
      }),
      ...(include([NO, 'btn_No'], dailyEcceActivitiesConducted) && {
        dailyEcceActivitiesNotConductedReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      wasEcceDayConductedDuringCurrentMonth: {
        label: 'job_WasEcceDayConductedDuringCurrentMonth',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], ecceDayConducted) && {
        ecceDayDate: {
          label: 'job_PleaseSpecifyTheDate',
          inputType: 'dateTimePicker',
          format: DISPLAY_DATE_FORMAT,
          className: 'w-100',
          required: true,
          md: 24,
          xs: 24,
        },
        ecceDayMinutesOfMeetingPhotoDmsIds: {
          label: 'job_UploadPicOfMinutesOfMeeting',
          inputType: 'formUpload',
          acceptFileTypes: '.png,.jpg,.jpeg',
          uploadSingle: true,
          galleryUpload: true,
          required: true,
          md: 24,
          xs: 24,
        },
      }),
      ...(include([NO, 'btn_No'], ecceDayConducted) && {
        ecceDayNotConductedReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
    }),
    [],
  )
  const suppliesAttrFn = useCallback(
    ({
      // malnourishedChildren = null,
      supplementsRegular = null,
      // imageCapturedThr = null,
      foodMenuChartDisplayed = null,
      morningSnacksGiven = null,
      imageCapturedForMorningSnacks = null,
      hotMealCookedAsPerMenu = null,
      // imageCapturedHotCookedMeal = null,
      areEggsAvailableAsPerSpecifications = null,
      isQualityOfRiceSatisfactory = null,
    } = {}) => ({
      totalNoOfTakeHomeRationGivenToBeneficiaries: {
        label: 'job_TotalNoOfTakeHomeRationGivenToBeneficiaries',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      // imageCapturedThr: {
      //   label: 'job_ImageCapturedThr',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // ...(include([YES, 'btn_Yes'], imageCapturedThr) && {
      //   imageCapturedThrPhotoDmsIds: {
      //     label: 'job_PhotoOfTHR',
      //     inputType: 'formUpload',
      //     acceptFileTypes: '.png,.jpg,.jpeg',
      //     uploadSingle: true,
      //     galleryUpload: true,
      //     required: true,
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
      // ...(include([NO, 'btn_No'], imageCapturedThr) && {
      //   imageCapturedThrNotCapturedReason: {
      //     label: 'job_PleaseSpecifyReason',
      //     inputType: 'input',
      //     required: true,
      //     className: 'w-100',
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
      // totalNoOfBeneficiariesGivenThrWithoutFrs: {
      //   label: 'job_TotalNoOfBeneficiariesGivenThrWithoutFrs',
      //   inputType: 'inputNumber',
      //   required: true,
      //   className: 'w-100',
      //   md: 24,
      //   xs: 24,
      // },
      // beneficiariesGivenThrWithoutFrsReason: {
      //   label: 'job_PleaseSpecifyReason',
      //   inputType: 'input',
      //   required: true,
      //   className: 'w-100',
      //   md: 24,
      //   xs: 24,
      // },
      areVegetablesStoredAboveGroundLevel: {
        label: 'job_AreVegetablesStoredAboveGroundLevel',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      isExhaustFanAvailableInKitchen: {
        label: 'job_IsExhaustFanAvailableInKitchen',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      areSupplementsExtraFoodsProvidedRegularly: {
        label: 'job_AreSupplementsExtraFoodsChikkisSnacksProvidedRegularly',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], supplementsRegular) && {
        supplementsQuantity: {
          label: 'job_Quantity',
          inputType: 'inputNumber',
          className: 'w-100',
          required: true,
          md: 24,
          xs: 24,
        },
        supplementsDateOfDistribution: {
          label: 'job_DateOfDistribution',
          inputType: 'dateTimePicker',
          className: 'w-100',
          format: DISPLAY_DATE_FORMAT,
          required: true,
          md: 24,
          xs: 24,
        },
      }),
      availabilityOfEggsTitle: {
        title: 'awc_availabilityOfEggs',
        titleClassName: 'small-title',
        md: 24,
        xs: 24,
      },
      eggsBookBalance: {
        label: 'awc_bookBalance',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      eggsActualBalance: {
        label: 'awc_actualBalanceAtPresent',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      areEggsAvailableAsPerSpecifications: {
        label: 'awc_areEggsAvailableAsPer',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([NO, 'btn_No'], areEggsAvailableAsPerSpecifications) && {
        eggsNotAvailableAsPerSpecificationsReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      availabilityOfRiceTitle: {
        title: 'awc_availabilityOfRice',
        titleClassName: 'small-title',
        md: 24,
        xs: 24,
      },
      riceBookBalance: {
        label: 'awc_bookBalance',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      riceActualBalance: {
        label: 'awc_actualBalanceAtPresent',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      isQualityOfRiceSatisfactory: {
        label: 'awc_isTheQualityOfRice',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([NO, 'btn_No'], isQualityOfRiceSatisfactory) && {
        qualityOfRiceNotSatisfactoryReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      availabilityOfMilkPacketsTitle: {
        title: 'awc_availabilityOfMilkPackets',
        titleClassName: 'small-title',
        md: 24,
        xs: 24,
      },
      milkPacketsBookBalance: {
        label: 'awc_bookBalance',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      milkPacketsActualBalance: {
        label: 'awc_actualBalanceAtPresent',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      availabilityOfOilPacketsTitle: {
        title: 'awc_availabilityOfOilPackets',
        titleClassName: 'small-title',
        md: 24,
        xs: 24,
      },
      oilPacketsBookBalance: {
        label: 'awc_bookBalance',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      oilPacketsActualBalance: {
        label: 'awc_actualBalanceAtPresent',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      availabilityOfBalamruthamPacketsTitle: {
        title: 'awc_availabilityOfBalamruthamPackets',
        titleClassName: 'small-title',
        md: 24,
        xs: 24,
      },
      balamruthamPacketsBookBalance: {
        label: 'awc_bookBalance',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      balamruthamPacketsActualBalance: {
        label: 'awc_actualBalanceAtPresent',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      availabilityOfBalamruthamPlusPacketsTitle: {
        title: 'awc_availabilityOfBalamruthamPlusPackets',
        titleClassName: 'small-title',
        md: 24,
        xs: 24,
      },
      balamruthamPlusPacketsBookBalance: {
        label: 'awc_bookBalance',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      balamruthamPlusPacketsActualBalance: {
        label: 'awc_actualBalanceAtPresent',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      availabilityOfMurukuluTitle: {
        title: 'awc_availabilityOfMurukulu',
        titleClassName: 'small-title',
        md: 24,
        xs: 24,
      },
      murukuluBookBalance: {
        label: 'awc_bookBalance',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      murukuluActualBalance: {
        label: 'awc_actualBalanceAtPresent',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      foodProcurementStorageIssuesModifications: {
        label: 'job_DescribeIssuesAndModificationsInFoodProcurementAndStorage',
        inputType: 'textArea',
        required: true,
        className: 'w-100',
        maxLength: 1000,
        md: 24,
        xs: 24,
      },
      isPrescribedAmountOfMilkBeingProvidedToChild: {
        label: 'job_IsPrescribedAmountOfMilkIsBeingProvidedToChild',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      // isMilkBeingMixedWithNutritionPowder: {
      //   label: 'job_IsTheMilkBeingMixedWithNutritionPowderLikeCerelacEtc',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   className: 'w-100',
      //   md: 24,
      //   xs: 24,
      // },
      // areThereAnyMalnourishedChildrenPresent: {
      //   label: 'job_AreThereAnyMalnourishedChildrenPresent',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // ...(include([YES, 'btn_Yes'], malnourishedChildren) && {
      //   isPrescribedNutritionGivenToMalnourishedChild: {
      //     label: 'job_IsThePrescribedNutritionGivenToTheMalNourishedChild',
      //     inputType: 'select',
      //     responsiveInputType: 'RADIO_BUTTON',
      //     options: booleanOptions,
      //     required: true,
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
      areEggsBeingProvided: {
        label: 'job_AreEggsBeingProvided',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      howManyEggsBeingProvidedToChild: {
        label: 'job_HowManyEggsAreBeingProvidedToAChild',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      // areEggsBeingProvidedToMother: {
      //   label: 'job_AreEggsBeingProvidedToTheMother',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      areFoodResourcesByVendorGivenToCentreOnTime: {
        label: 'job_AreTheFoodResourcesByTheVendorBeingGivenToTheCentreOnTime',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      suppliesPhoto1Ids: {
        label: 'job_PhotoOfSupplies1',
        inputType: 'formUpload',
        acceptFileTypes: '.png,.jpg,.jpeg',
        uploadSingle: true,
        galleryUpload: true,
        required: true,
        md: 24,
        xs: 24,
      },
      suppliesPhoto2Ids: {
        label: 'job_PhotoOfSupplies2',
        inputType: 'formUpload',
        acceptFileTypes: '.png,.jpg,.jpeg',
        uploadSingle: true,
        galleryUpload: true,
        required: true,
        md: 24,
        xs: 24,
      },
      whetherFoodMenuChartDisplayedInAwc: {
        label: 'job_WhetherFoodMenuChartDisplayedInAwc',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([NO, 'btn_No'], foodMenuChartDisplayed) && {
        foodMenuChartNotDisplayedReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      whetherMorningSnacksGivenToBeneficiaries: {
        label: 'job_WhetherMorningSnacksGivenToBeneficiaries',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([NO, 'btn_No'], morningSnacksGiven) && {
        morningSnacksNotGivenReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      imageCapturedForMorningSnacks: {
        label: 'job_ImageCapturedForMorningSnacks',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], imageCapturedForMorningSnacks) && {
        imageCapturedForMorningSnacksPhotoDmsIds: {
          label: 'job_MorningSnacksPhoto',
          inputType: 'formUpload',
          acceptFileTypes: '.png,.jpg,.jpeg',
          uploadSingle: true,
          galleryUpload: true,
          required: true,
          md: 24,
          xs: 24,
        },
      }),
      ...(include([NO, 'btn_No'], imageCapturedForMorningSnacks) && {
        imageCapturedForMorningSnacksNotCapturedReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      whetherHotMealCookedAsPerMenu: {
        label: 'job_WhetherHotMealCookedAsPerMenu',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([NO, 'btn_No'], hotMealCookedAsPerMenu) && {
        hotMealNotCookedAsPerMenuReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      // totalNoOfHotCookedMealGivenToBeneficiaries: {
      //   label: 'job_TotalNoOfHotCookedMealGivenToBeneficiaries',
      //   inputType: 'inputNumber',
      //   required: true,
      //   className: 'w-100',
      //   md: 24,
      //   xs: 24,
      // },
      // imageCapturedHotCookedMeal: {
      //   label: 'job_ImageCapturedHotCookedMeal',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // ...(include([YES, 'btn_Yes'], imageCapturedHotCookedMeal) && {
      //   imageCapturedHotCookedMealPhotoDmsIds: {
      //     label: 'job_HotCookedMealPhoto',
      //     inputType: 'formUpload',
      //     acceptFileTypes: '.png,.jpg,.jpeg',
      //     uploadSingle: true,
      //     galleryUpload: true,
      //     required: true,
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
      // ...(include([NO, 'btn_No'], imageCapturedHotCookedMeal) && {
      //   imageCapturedHotCookedMealNotCapturedReason: {
      //     label: 'job_PleaseSpecifyReason',
      //     inputType: 'input',
      //     required: true,
      //     className: 'w-100',
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
    }),
    [],
  )
  const generalHealthAttrFn = useCallback(
    () => ({
      areGrowthMeasurementsTakenAsPerWhoStandards: {
        label:
          'job_AreTheGrowthMeasurementsBeingTakenAsPerWHOStandardsForHeightAndWeight',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      isGrowthMonitoringDoneRegularly: {
        label: 'job_GrowthMonitoringIsDoneRegularly',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      // isChildPhysicallyFit: {
      //   label: 'job_IsTheChildPhysicallyFit',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // isChildMentallyFit: {
      //   label: 'job_IsTheChildMentallyFit',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // doesChildCanWalkProperlyAndMakeHandMovements: {
      //   label: 'job_DoesTheChildCanWalkProperlyAndMakeHandMovements',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // doesChildCommunicateVerbally: {
      //   label: 'job_DoesTheChildCommunicateVerbaly',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      areChildrenAbleToIdentifyShapesNumbersAnimalsAndThings: {
        label: 'job_AreChildrenAbleToIdentifyShapesNumbersAnimalsAndThings',
        inputType: 'select',
        options: [
          { label: 'job_VeryFewChildren', value: 'VERY_FEW_CHILDREN' },
          { label: 'job_SomeChildren', value: 'SOME_CHILDREN' },
          { label: 'job_AlmostAllChildren', value: 'ALMOST_ALL_CHILDREN' },
        ],
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      // doesChildVisuallyRecognize: {
      //   label: 'job_DoesTheChildVisuallyRecognize',
      //   inputType: 'select',
      //   mode: 'multiple',
      //   options: [
      //     { value: 'COLORS', label: 'job_Colors' },
      //     { value: 'SHAPES', label: 'job_Shapes' },
      //     { value: 'OBJECTS', label: 'job_Objects' },
      //     { value: 'PARENTS', label: 'job_Parents' },
      //   ],
      //   required: true,
      //   md: 24,
      //   xs: 24,
      //   note: 'job_IfNonOfTheseAreObservedInAChildContactNearbyPHC',
      // },
      // areTheyFollowingAccordingToNhmGuidelines: {
      //   label: 'job_AreTheyFollowingAccordingToTheNHMGuildlines',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      isFirstAidKitAvailableAtAllTimes: {
        label: 'job_IsFirstAidKitAvailableAtAllTimes',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      // isThereAnySuddenLossOrGainOfWeightOfChild: {
      //   label: 'job_IsThereAnySuddenLossOrGainOfTheWeightOfTheChild',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   className: 'w-100',
      //   md: 24,
      //   xs: 24,
      // },
      // ...(include([YES, 'btn_Yes'], weightChange) && {
      //   describeWeightLossGainAndContactDoctor: {
      //     label: 'job_DescribeInWordsAndContactTheDoctor',
      //     inputType: 'input',
      //     required: true,
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
      // nutrition: { title: 'job_Nutrition' },
      // isChildNourishedProperly: {
      //   label: 'job_IsTheChildNourishedProperly',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // isChildMalnourished: {
      //   label: 'job_IsTheChildMalNourished',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // ...(include([YES, 'btn_Yes'], malNourished) && {
      //   malnutritionReasons: {
      //     label: 'job_Why',
      //     inputType: 'CHECKBOX',
      //     options: [
      //       {
      //         label: 'job_DueToLackOfFoodSupply',
      //         value: 'DUE_TO_LACK_OF_FOOD_SUPPLY',
      //       },
      //       {
      //         label: 'job_DueToUnderlyingHealthConditions',
      //         value: 'DUE_TO_UNDERLYING_HEALTH_CONDITIONS',
      //       },
      //     ],
      //     required: true,
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
      // isChildObese: {
      //   label: 'job_IsTheChildObese',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // ...(include([YES, 'btn_Yes'], obeseChild) && {
      //   obesityReasons: {
      //     label: 'job_Why',
      //     inputType: 'CHECKBOX',
      //     options: [
      //       {
      //         label: 'job_DueToOverFeeding',
      //         value: 'DUE_TO_OVER_FEEDING',
      //       },
      //       {
      //         label: 'job_DueToUnderlyingHealthIssues',
      //         value: 'DUE_TO_UNDERLYING_HEALTH_ISSUES',
      //       },
      //     ],
      //     required: true,
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
      // isChildGettingSupplementsFromAnganwadiCentre: {
      //   label: 'job_IfTheChildGettingSupplementsFromTheAnganwadiCentre',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      isVitaminSupplementsIfaSyrupsGiven: {
        label: 'job_VitaminSupplimentsIFASyrups',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      isVitaminAGiven: {
        label: 'job_VitaminA',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      isChildGettingCourseOfAlbendazoleMedication: {
        label: 'job_IsTheChildGettingACourseOfAlbendazoleMedication',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      // vaccination: { title: 'job_Vaccination' },
      // isImmunizationCardSafeAndBringAlongForNextVisit: {
      //   label: 'job_IsTheImmunizationCardSafeAndBringItAlongForTheNextVisit',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // whenAndWhereToComeForVaccinationInstructionsGiven: {
      //   label: 'job_WhenAndWhereToComeForVaccinationAreTheInstructionsGiven',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // areParentInstructedForMinorAdverseEvents: {
      //   label: 'job_AreTheParentInstructedForMinorAdverseEvents',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // isPersonImmunizingChildAwareOfVaccineAndChildDetails: {
      //   label:
      //     'job_IsThePersonImmunizingTheChildAwareOfWhichVaccineAndChildDetails',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // inventory: { title: 'job_Inventory' },
      // listOfVaccineAvailable: {
      //   label: 'job_ListOfVaccineAvailable',
      //   inputType: 'select',
      //   mode: 'multiple',
      //   options: [
      //     { label: 'OPV', value: 'OPV' },
      //     { label: 'Penta', value: 'PENTA' },
      //     { label: 'Hep B', value: 'HEP_B' },
      //     { label: 'BCG', value: 'BCG' },
      //     { label: 'PCV', value: 'PCV' },
      //     { label: 'Rota', value: 'ROTA' },
      //     { label: 'IPV', value: 'IPV' },
      //     { label: 'MR', value: 'MR' },
      //     { label: 'JE', value: 'JE' },
      //     { label: 'TD', value: 'TD' },
      //   ],
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // isAllMedicationsAvailable: {
      //   label: 'job_IsAllMedicationsAvailable',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // anyMedicationsMissed: {
      //   label: 'job_AnyMedicationsMissed',
      //   inputType: 'input',
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // howFrequentlyVaccinesAreToppedUp: {
      //   label: 'job_HowFrequentlyVaccinesAreToppedUp',
      //   inputType: 'input',
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // howFrequentlyMedicineAreToppedUp: {
      //   label: 'job_HowFrequentlyMedicineAreToppedUp',
      //   inputType: 'input',
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
    }),
    [],
  )
  const phcConnectivityAttrFn = useCallback(
    () => ({
      isTherePhcLocatedNearAnganwadiOrHealthWorkerPresent: {
        label:
          'job_IsThereAnyPHCLocatedNearAnganwadiOrHealthCareWorkerNurseDoctorPresent',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      isMedicalCheckupsHappeningFrequently: {
        label: 'job_IsTheMedicalCheckUpsHappeningFrequently',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      doesMedicalOfficerMakeRegularVisits: {
        label: 'job_DoesTheMedicalOfficerMakeRegularVisits',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      distanceToNearestPhcKm: {
        label: 'job_DistanceToNearestPHCKM',
        inputType: 'inputNumber',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
    }),
    [],
  )
  const feedbackAttrFn = useCallback(
    ({
      healthCheckupsConducted = null,
      almscCommitteeMeetingConducted = null,
      // healthCheckupsConductedSecond = null,
      homeVisitsConducted = null,
      vhsndMeetingConducted = null,
      communityBasedEventsConducted = null,
      // anySuggestions = null,
    } = {}) => ({
      anyResourcesAreLacking: {
        label: 'job_AnyResourcesAreLacking',
        inputType: 'input',
        required: true,
        className: 'w-100',
        md: 24,
        xs: 24,
      },
      feedbackRegardingMedicalCareAndHealthStatusOfChildren: {
        label:
          'job_FeedbackRegardingMedicalCareAndHealthStatusOfChildrenAndIfAnyRecurringDiseasesLikeFeverDengueDiarrhoeaVomitingsEtc',
        inputType: 'textArea',
        required: true,
        maxLength: 1000,
        md: 24,
        xs: 24,
      },
      feedbackOnEducationalStatusOfChildren: {
        label:
          'job_FeedbackOnEducationalStatusOfChildrenStudentsWithDifficultyInLearningEtc',
        inputType: 'textArea',
        required: true,
        maxLength: 1000,
        md: 24,
        xs: 24,
      },
      feedbackFromParentsAndStudents: {
        label: 'job_FeedbackFromParentsAndStudents',
        inputType: 'input',
        required: true,
        md: 24,
        xs: 24,
      },
      feedbackFromStaff: {
        label: 'job_FeedbackFromStaff',
        inputType: 'input',
        required: true,
        md: 24,
        xs: 24,
      },
      healthCheckupsConductedForChildrenAtAwcCurrentMonth: {
        label:
          'job_WereHealthCheckupsConductedForAllChildrenAtAwcDuringCurrentMonth',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], healthCheckupsConducted) && {
        healthCheckupsConductedDate: {
          label: 'job_PleaseSpecifyTheDate',
          inputType: 'dateTimePicker',
          className: 'w-100',
          format: DISPLAY_DATE_FORMAT,
          required: true,
          md: 24,
          xs: 24,
        },
        healthCheckupsConductedPhotoDmsIds: {
          label: 'job_UploadPic',
          inputType: 'formUpload',
          acceptFileTypes: '.png,.jpg,.jpeg',
          uploadSingle: true,
          galleryUpload: true,
          required: true,
          md: 24,
          xs: 24,
        },
      }),
      ...(include([NO, 'btn_No'], healthCheckupsConducted) && {
        healthCheckupsNotConductedReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      wasAlmscCommitteeMeetingConductedDuringCurrentMonth: {
        label: 'job_WasAlmscCommitteeMeetingConductedDuringCurrentMonth',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], almscCommitteeMeetingConducted) && {
        almscCommitteeMeetingDate: {
          label: 'job_PleaseSpecifyTheDate',
          inputType: 'dateTimePicker',
          className: 'w-100',
          format: DISPLAY_DATE_FORMAT,
          required: true,
          md: 24,
          xs: 24,
        },
        // almscCommitteeMeetingMinutesPhotoDmsIds: {
        //   label: 'job_UploadPicOfMinutesOfMeeting',
        //   inputType: 'formUpload',
        //   acceptFileTypes: '.png,.jpg,.jpeg',
        //   uploadSingle: true,
        //   galleryUpload: true,
        //   required: true,
        //   md: 24,
        //   xs: 24,
        // },
      }),
      ...(include([NO, 'btn_No'], almscCommitteeMeetingConducted) && {
        almscCommitteeMeetingNotConductedReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      // wereHealthCheckupsConductedForAllChildrenAtAwcDuringCurrentMonthSecond: {
      //   label:
      //     'job_WereHealthCheckupsConductedForAllChildrenAtAwcDuringCurrentMonthSecond',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // ...(include([YES, 'btn_Yes'], healthCheckupsConductedSecond) && {
      //   healthCheckupsSecondDate: {
      //     label: 'job_PleaseSpecifyTheDate',
      //     inputType: 'dateTimePicker',
      //     className: 'w-100',
      //     format: DISPLAY_DATE_FORMAT,
      //     required: true,
      //     md: 24,
      //     xs: 24,
      //   },
      //   healthCheckupsSecondPhoto: {
      //     label: 'job_UploadPic',
      //     inputType: 'formUpload',
      //     acceptFileTypes: '.png,.jpg,.jpeg',
      //     uploadSingle: true,
      //     galleryUpload: true,
      //     required: true,
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
      // ...(include([NO, 'btn_No'], healthCheckupsConductedSecond) && {
      //   healthCheckupsSecondNotConductedReason: {
      //     label: 'job_PleaseSpecifyReason',
      //     inputType: 'input',
      //     required: true,
      //     className: 'w-100',
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
      wereHomeVisitsConductedDuringCurrentMonthAsPerTarget: {
        label: 'job_WereHomeVisitsConductedDuringCurrentMonthAsPerTarget',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], homeVisitsConducted) && {
        homeVisitsConductedNumber: {
          label: 'job_PleaseSpecifyNo',
          inputType: 'inputNumber',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      ...(include([NO, 'btn_No'], homeVisitsConducted) && {
        homeVisitsNotConductedReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      wasVhsndMeetingConductedDuringCurrentMonth: {
        label: 'job_WasVhsndMeetingConductedDuringCurrentMonth',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], vhsndMeetingConducted) && {
        vhsndMeetingDate: {
          label: 'job_PleaseSpecifyTheDate',
          inputType: 'dateTimePicker',
          className: 'w-100',
          format: DISPLAY_DATE_FORMAT,
          required: true,
          md: 24,
          xs: 24,
        },
        // vhsndMeetingMinutesPhotoDmsIds: {
        //   label: 'job_UploadPicOfMinutesOfMeeting',
        //   inputType: 'formUpload',
        //   acceptFileTypes: '.png,.jpg,.jpeg',
        //   uploadSingle: true,
        //   galleryUpload: true,
        //   required: true,
        //   md: 24,
        //   xs: 24,
        // },
      }),
      ...(include([NO, 'btn_No'], vhsndMeetingConducted) && {
        vhsndMeetingNotConductedReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      wereCommunityBasedEventsConductedDuringCurrentMonth: {
        label: 'job_WereCommunityBasedEventsConductedDuringCurrentMonth',
        inputType: 'select',
        responsiveInputType: 'RADIO_BUTTON',
        options: booleanOptions,
        required: true,
        md: 24,
        xs: 24,
      },
      ...(include([YES, 'btn_Yes'], communityBasedEventsConducted) && {
        communityBasedEventsDate: {
          label: 'job_PleaseSpecifyTheDate',
          inputType: 'dateTimePicker',
          className: 'w-100',
          format: DISPLAY_DATE_FORMAT,
          required: true,
          md: 24,
          xs: 24,
        },
        // communityBasedEventsPhotoDmsIds: {
        //   label: 'job_UploadPicOfMinutesOfMeeting',
        //   inputType: 'formUpload',
        //   acceptFileTypes: '.png,.jpg,.jpeg',
        //   uploadSingle: true,
        //   galleryUpload: true,
        //   required: true,
        //   md: 24,
        //   xs: 24,
        // },
      }),
      ...(include([NO, 'btn_No'], communityBasedEventsConducted) && {
        communityBasedEventsNotConductedReason: {
          label: 'job_PleaseSpecifyReason',
          inputType: 'input',
          required: true,
          className: 'w-100',
          md: 24,
          xs: 24,
        },
      }),
      // anySuggestions: {
      //   label: 'job_AnySuggestions',
      //   inputType: 'select',
      //   responsiveInputType: 'RADIO_BUTTON',
      //   options: booleanOptions,
      //   required: true,
      //   md: 24,
      //   xs: 24,
      // },
      // ...(include([YES, 'btn_Yes'], anySuggestions) && {
      //   suggestionsDetails: {
      //     label: 'job_PleaseSpecify',
      //     inputType: 'input',
      //     required: true,
      //     className: 'w-100',
      //     md: 24,
      //     xs: 24,
      //   },
      // }),
    }),
    [],
  )

  const findingsAttrFn = useCallback(
    () => ({
      repairsOtherThanMentionedEarlier: {
        label: 'job_RepairsDescription',
        inputType: 'textArea',
        required: true,
        maxLength: 1000,
        md: 24,
        xs: 24,
      },
      findingsOfInspectionOfficer: {
        label: 'job_InspectionFindings',
        inputType: 'textArea',
        required: true,
        maxLength: 2000,
        md: 24,
        xs: 24,
      },
      photoOfInspectingOfficerWithStaff: {
        label: 'job_OfficerStaffPhoto',
        inputType: 'formUpload',
        acceptFileTypes: '.png,.jpg,.jpeg',
        uploadSingle: true,
        galleryUpload: true,
        required: true,
        md: 24,
        xs: 24,
      },
      photoOfInspectingOfficerWithChildren: {
        label: 'job_OfficerChildrenPhoto',
        inputType: 'formUpload',
        acceptFileTypes: '.png,.jpg,.jpeg',
        uploadSingle: true,
        galleryUpload: true,
        required: true,
        md: 24,
        xs: 24,
      },
      photoOfMainGate: {
        label: 'job_AddPhotoOfMainGate',
        inputType: 'formUpload',
        acceptFileTypes: '.png,.jpg,.jpeg',
        required: true,
        uploadSingle: true,
        galleryUpload: true,
        md: 24,
        xs: 24,
      },
      photoOfAnganwadiFrontFaceWithName: {
        label: 'job_AddPhotoOfHostelFrontWithName',
        inputType: 'formUpload',
        acceptFileTypes: '.png,.jpg,.jpeg',
        required: true,
        uploadSingle: true,
        galleryUpload: true,
        md: 24,
        xs: 24,
      },
    }),
    [],
  )

  return {
    administrationAttrFn,
    hostelInfraRoomsAttrFn,
    childrenAttrFn,
    educationAttrFn,
    suppliesAttrFn,
    generalHealthAttrFn,
    phcConnectivityAttrFn,
    feedbackAttrFn,
    findingsAttrFn,
  }
}

export default inspectionFieldAttr
